import type { LoginErrorCode } from "@nexxt/contracts/identity";

/** Failures that signing in again can fix; for the others the user needs an administrator or support. */
const RETRYABLE = new Set<LoginErrorCode>(["login_expired", "login_failed", "internal_error"]);

/** The gateway's Logto login (ADR-037), then back to `returnTo`. */
export const loginHref = (returnTo: string) => `/auth/login?returnTo=${encodeURIComponent(returnTo)}`;

/** Where the sign-in page's button leads: null when signing in again cannot help. */
export function signInAction(error: LoginErrorCode | undefined, returnTo: string): string | null {
  return error === undefined || RETRYABLE.has(error) ? loginHref(returnTo) : null;
}
